























































import Vue from 'vue';
import { mapActions } from 'vuex';
import { Component, Prop } from 'vue-property-decorator';
import UpdateExpHooksModal from './UpdateExpHooksModal.vue';
import UploadExpRates from './ExpHookUploadRates.vue';

@Component({
    methods: {
        ...mapActions('bh-exp-hooks', { saveNewExpHook: 'create' })
    },
    components: {
        UpdateExpHooksModal,
        UploadExpRates
    }
})
export default class ExpTableHooks extends Vue {
    dialogAdd = false;
    dialogLoading = false;
    form = {
        name: null,
        description: null,
        exp_amount: null,
        hook_service: null,
        hook_method: 'create',
        esb_hook: null
    };

    headers = [
        {
            text: 'Name/Description',
            align: 'start',
            sortable: false,
            value: 'name',
        },
        {
            text: 'Total Data',
            align: 'center',
            sortable: false,
            value: 'total_subitem'
        },
        {
            text: 'Actions',
            align: 'end',
            value: 'data-table-expand'
        }
    ];
    query = { /*id: { $nin: [this.user.id] }*/ };
    pagination = {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: []
    };
    
    saveNewExpHook: any;

    public get fetchQuery() {
        return Object.assign({}, {
            ...this.query,
            // ...this.extendedQuery,
            $populate: true
        }, {
            // ...this.searchQuery,
            $limit: this.pagination.itemsPerPage,
            $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
            ...this.sortingQuery
        });
    }

    public get dataQuery() {
        return {
            ...this.query,
            // ...this.extendedQuery,
            // ...this.searchDataQuery,
            $limit: this.pagination.itemsPerPage,
            $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
            ...this.sortingQuery
        };
    }

    public get sortingQuery() {
        if(this.pagination.sortBy.length !== 0) {
            const $sort: any = {};
            this.pagination.sortBy.map((item, index) => {
                switch(item) {
                    default:
                        $sort[item] = this.pagination.sortDesc[index] ? -1 : 1;
                }
                
            });
            return { $sort };
        }
        return null;
    }

    public async addExpTemplate() {
        try {
            this.dialogLoading = true;
            await this.saveNewExpHook(this.form);
            this.form.name = null;
            this.form.description = null;
            this.form.exp_amount = null;
            this.form.hook_service = null;
            this.form.esb_hook = null;
            this.dialogAdd = false;
            this.$emit('success');
        } catch(err) {
            this.$emit('error', err);
        } finally {
            this.dialogLoading = false;
        }
    }

    public servicesFilter(items: any[]) {
        return [
            'authentication',
            ...items.map(i => i.id).filter(service => [
                'logic-control',
                'cities',
                'countries',
                'regions',
                'logic-control-category',
                'bh-app-error-log',
                'bh-app-version',
                'bh-exp-tables',
                'access-control-services',
                'bh-user-obtained-exp',
                'bh-exp-hooks'
            ].indexOf(service) === -1)
        ];
    }
}
